// extracted by css-extract-rspack-plugin
export default {"StyledParametersList":"lZUkC","ParametersListContainer":"EML7M","isSmallScreen":"qQs8b","isShowingMobile":"XT10M"};